/**
 * JobManagementPage — Page wrapper for the job management wizard
 *
 * Route: /settings/job-management
 */

import { PageHeader } from '@/shared/components/PageHeader';
import { Briefcase } from 'lucide-react';
import JobManagementWizard from '../components/JobManagementWizard';

export default function JobManagementPage() {
  return (
    <div className="h-full flex flex-col bg-background overflow-hidden">
      <PageHeader
        title="Job Management"
        subtitle="Configure job categories, task types, and assignments"
        icon={<Briefcase className="w-7 h-7" style={{ color: '#E84A2B' }} />}
      />

      <div className="flex-1 overflow-y-auto px-6 pb-6">
        <div className="max-w-5xl mx-auto">
          <JobManagementWizard />
        </div>
      </div>
    </div>
  );
}
